// todo can we use for all statuses?
export enum SeamStatus {
    ASSIGN = 'assign',
    TUNE = 'tune',
    LABEL = 'label',
    REVIEW = 'review',
    TXN_CHECK = 'txn_check',
    MIDMATCHING = 'awaiting_midmatch',
    PREPROD = 'pre-prod',
    QA = 'qa',
    PROD = 'prod',
    PROD_QA = 'prod_qa',
    CLOSED = 'done',
    PROGRESS = 'progress',
    CANCELLED = 'cancel',
}
